// import '@rowinski/rwn-assets/src/js/app';

import 'bootstrap';
import CollapseAndDestructListener from "@rowinski/rwn-assets/src/js/custom/CollapseAndDestructListener";
import PopupListener from "@rowinski/rwn-assets/src/js/custom/PopupListener";
import CookiesAlert from "@rowinski/rwn-assets/src/js/custom/CookiesAlert";


const collapseAndDestructListener = new CollapseAndDestructListener();
const popupListener = new PopupListener();
const cookiesAlert = new CookiesAlert();

import './custom';